import { render, staticRenderFns } from "./产权需求详情_自由竞价版本_socket.vue?vue&type=template&id=4af526ed&scoped=true"
import script from "./产权需求详情_自由竞价版本_socket.vue?vue&type=script&lang=js"
export * from "./产权需求详情_自由竞价版本_socket.vue?vue&type=script&lang=js"
import style0 from "./产权需求详情_自由竞价版本_socket.vue?vue&type=style&index=0&id=4af526ed&prod&lang=css"
import style1 from "./产权需求详情_自由竞价版本_socket.vue?vue&type=style&index=1&id=4af526ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af526ed",
  null
  
)

export default component.exports